// OficinaProfesional.js
import React, { useState, useEffect } from 'react';
import { useAuth } from "../context/AuthContext.js";
import { db } from "../firebaseConfig.js";
import { getFirestore, getDoc, doc } from "firebase/firestore";
import Menu from './Menu.js';
import Solicitudes from './Solicitudes.js';
import MensajesOP from './MensajesOP.js';
import Config from './Config.js';
import CRM from './CRM.js';
import SentRequests from './SentRequests.js';
import "./OficinaProfesional.css";
import {FaCog,} from "react-icons/fa";

const OficinaProfesional = () => {
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState("config");
  const [categoria, setCategoria] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [solicitudes, setSolicitudes] = useState([]);
  const [currentSolicitudId, setCurrentSolicitudId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [presupuestoTexto, setPresupuestoTexto] = useState("");
  const [mensajeTexto, setMensajeTexto] = useState("");
  const [media, setMedia] = useState(null);

  const db = getFirestore();

  useEffect(() => {
    const fetchDescription = async () => {
      if (currentSolicitudId) {
        const docRef = doc(db, "solicitudservicios", currentSolicitudId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setDescripcion(docSnap.data().description);
        }
      }
    };

    if (isModalOpen && currentSolicitudId) {
      fetchDescription();
    }
  }, [isModalOpen, currentSolicitudId]);

  const handleTabChange = (tab) => setActiveTab(tab);


  const handleSaveConfig = (e) => {
    e.preventDefault();
    alert("Configuración guardada.");
  };

  return (
    <div className="vp-container">
      <Menu />
      <div className="vp-main-content">
        <div className="user-office">
          <div className="office-menu">
           
            <button className={`tab-btn ${activeTab === "solicitudes" ? "active" : ""}`} onClick={() => handleTabChange("solicitudes")}>Solic.</button>
            <button className={`tab-btn ${activeTab === "requests" ? "active" : ""}`} onClick={() => handleTabChange("requests")}>Serv.</button>
            <button className={`tab-btn ${activeTab === "crm" ? "active" : ""}`} onClick={() => handleTabChange("crm")}>CRM</button>
            <button className={`tab-btn ${activeTab === "mensajes" ? "active" : ""}`} onClick={() => handleTabChange("mensajes")}>
                <i className={`fa-solid ${activeTab === "mensajes" ? "fa-envelope-open-text" : "fa-envelope"}`}></i>
            </button>
            <button className={`tab-btn ${activeTab === "config" ? "active" : ""}`} onClick={() => handleTabChange("config")}> <span><FaCog /></span></button>
          </div>

          <div className="tab-content">
            {activeTab === "solicitudes" && <Solicitudes solicitudes={solicitudes} handleVerSolicitud={setCurrentSolicitudId} />}
            {activeTab === "requests" && <SentRequests />}
            {activeTab === "crm" && <CRM />}
            {activeTab === "mensajes" && <MensajesOP />}
            {activeTab === "config" && <Config categoria={categoria} setCategoria={setCategoria} descripcion={descripcion} setDescripcion={setDescripcion} handleSaveConfig={handleSaveConfig} setMedia={setMedia} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OficinaProfesional;
